import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Order } from '@features/user/interfaces/order.interface';
import { OrderService } from '@features/user/services/order.service';
import {
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faFileAlt,
  faInfoCircle,
  faMoneyBill,
  faSpinner,
  faStore,
  faTruck,
} from '@fortawesome/free-solid-svg-icons';
import { LayoutService } from 'src/app/layout/services/layout.service';
@Component({
  selector: 'fc-user-order-detail',
  templateUrl: './user-order-detail.component.html',
  styleUrls: ['./user-order-detail.component.css'],
})
export class UserOrderDetailComponent implements OnInit, OnDestroy {
  faChevronLeft = faChevronLeft;
  faFileAlt = faFileAlt;
  faMoneyBill = faMoneyBill;
  faTruck = faTruck;
  faCheck = faCheck;
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;
  faStore = faStore;
  faChevronRight = faChevronRight;
  faInfoCircle = faInfoCircle;
  faSpinner = faSpinner;

  shopDefaultImg = 'assets/images/shop/default-shop-logo.webp';
  productDefaultImg: string = 'assets/images/product/default-product.png';

  orderId: number;
  order: Order = {} as Order;

  toggleTrackPackage = false;

  accLoading = false;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private location: Location,
    private router: Router,
    private layoutService: LayoutService
  ) {
    this.orderId = Number(this.route.snapshot.paramMap.get('orderId'));
    if (this.layoutService.isMobile$) {
      this.layoutService.setFooterVisibility(false);
      this.layoutService.setMobileLayoutConfig({
        headerNav: {
          backButton: true,
          title: 'Order Detail',
          searchButton: false,
          cartButton: false,
          notificationButton: false,
          userButton: true,
        },
        bottomNav: {
          visibillity: false,
        },
      });
    }
  }
  ngOnDestroy(): void {
    if (this.layoutService.isMobile$) {
      this.layoutService.setFooterVisibility(true);
      this.layoutService.setDefaultMobileLayoutConfig();
    }
  }

  ngOnInit(): void {
    this.orderService.getOrderDetail(this.orderId).subscribe((data) => {
      this.order = data;
    });
  }

  handleShopImgError() {
    this.shopDefaultImg = 'assets/images/shop/default-shop-logo.webp';
  }
  handleProductImgError() {
    this.productDefaultImg = 'assets/images/product/default-product.png';
  }

  translateOrderStatus(status: number) {
    return this.orderService.translateOrderStatus(status);
  }

  openBuyAgainModal() {
    // note: need feature open buy again
    // this.orderService.setbuyAgainOrderState(this.order.shop_name, this.order.lines);
    // this.modalService.openModal(OrderBuyAgainModalComponent, 'md', 'common-modal', true);
  }

  navigateToStatus() {
    this.router.navigate(['/user/order/status', this.orderId]);
  }

  acceptOrder() {
    if (!this.accLoading) {
      this.accLoading = true;
      this.orderService.acceptOrder(this.orderId).subscribe(
        (res: any) => {
          this.order.status = 3;
          this.accLoading = false;
        },
        (error: any) => {
          this.accLoading = false;
        }
      );
    }
  }

  reportHandler() {
    this.order.status = 6;
  }

  openModal(elem: any) {
    // this.modalService.openModal(OrderBuyAgainModalComponent, 'md', 'common-modal', true, null, '57px');
  }

  back() {
    this.location.back();
  }
}
